<script setup>

import { watch } from 'vue';
import { useCurrentMenuStore } from '../../stores/current-menu';

const currentMenuStore = useCurrentMenuStore();

const props = defineProps({
    item: { required: true },
    menuItem: { required: true },
});

// update item price when price_id changes
watch(props.item, () => {
    if (props.item.price_id != 0) {
        getPrice();
    }
});

function getPrice() {

    let prices = currentMenuStore.menuItems.filter((item) => {
        return item.product_id === props.menuItem.product_id;
    })[0].all_prices;

    prices = JSON.parse(prices);

    let result = prices.find(obj => {
        return obj.PriceId == props.item.price_id;
    })

    if (!result) return;

    props.item.price = result.GrossPrice;
}

</script>

<template>
    <div class="flex">
        <input type="checkbox" v-model="item.active">
        <p class="wine__title">{{ item.size }}</p>
    </div>
    <div>
        <label for="">Price ID</label>
        <input type="number" id="wine" v-model="item.price_id">
    </div>
    <div>
        <label for="">Price</label>
        <input type="number" id="wine" v-model="item.price">
    </div>
    <div>
        <label for="">Calories</label>
        <input type="number" id="wine" v-model="item.calories">
    </div>
</template>

<style scoped lang="scss">
@import '../../../scss/partials/variables';

input[type="checkbox"] {
    margin: 0;

    @media screen and (max-width: $breakpoint-sm) {
        margin-right: 5px;
    }
}

.wine {
    div {
        @media screen and (max-width: $breakpoint-sm) {
            width: 100%;
        }
    }

    label {
        @media screen and (max-width: $breakpoint-lg) {
            font-size: 14px;
        }
    }

    .flex {
        @media screen and (max-width: $breakpoint-sm) {

            width: fit-content;

        }
    }

    &__title {
        @media screen and (max-width: $breakpoint-sm) {
            margin-right: 5px;
        }
    }
}

.flex {
    display: flex;

    .input[type='checkbox'] {
        margin-right: 10px;
    }

    @media screen and (max-width: $breakpoint-sm) {
        width: fit-content;
    }
}
</style>